import { render, staticRenderFns } from "./type-manage.vue?vue&type=template&id=26f2fd5a&"
import script from "./type-manage.vue?vue&type=script&lang=js&"
export * from "./type-manage.vue?vue&type=script&lang=js&"
import style0 from "./type-manage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports